import BigNumber from 'bignumber.js';
import { BigNumberConstructable } from '../lib/customType';

const getRegExp = decimalPlaces => new RegExp(`^(\\d+(\\.\\d{0,${decimalPlaces}})?|\\.?\\d{1,${decimalPlaces}})$`);

export default function validateDecimalPlaces(value: BigNumberConstructable, decimalPlaces: number): boolean {
  return getRegExp(decimalPlaces).test(new BigNumber(value).toFixed());
}
